<ng-template #groupTpl let-group>
  <div class="flex flex-col gap-2">
    @if (group.label || maxSelectable() !== 1) {
      <div class="flex items-center justify-between gap-2">
        @if (group.label) {
          <span tuiTitle>{{ group.label }}</span>
        } @else {
          <span></span>
        }
        @if (maxSelectable() !== 1) {
          @let state = groupState(group);
          <label tuiLabel>
            <input
              tuiCheckbox
              type="checkbox"
              [indeterminate]="state === 'some'"
              [ngModel]="state === 'all'"
              (ngModelChange)="toggleGroup(group)" />
          </label>
        }
      </div>
    }
    <div class="grid grid-cols-3 gap-2 lg:grid-cols-5">
      @for (item of group.items; track getMediaListItemKey(item)) {
        <ng-container *ngTemplateOutlet="tile; context: { $implicit: item }" />
      } @empty {
        <tui-block-status *transloco="let t" class="col-span-full bg-background-primary" [card]="true">
          {{ t('Aucune image') }}
        </tui-block-status>
      }
    </div>
  </div>
</ng-template>

<ng-template #tile let-item>
  @let key = getMediaListItemKey(item);
  @let selected = isSelected(key);
  @let selectable = isSelectableFn(item);
  <button
    class="group relative aspect-square overflow-hidden rounded-sm bg-background-brand-secondary p-0 transition-colors"
    type="button"
    [attr.data-testid]="item.type === 'media' ? 'media-picker-media-' + item.media.id : 'media-picker-file-' + key"
    [class.cursor-not-allowed]="!selectable"
    [class.cursor-pointer]="selectable"
    [class.opacity-30]="!selectable"
    [disabled]="!selectable"
    (click)="toggle(item)">
    <div
      class="pointer-events-none relative size-full origin-center overflow-hidden rounded-sm transition-transform"
      [class.scale-90]="selected">
      @if (itemTemplate(); as custom) {
        <ng-container *ngTemplateOutlet="custom; context: { $implicit: item, source: sourceOf(item) }" />
        <ng-container *ngTemplateOutlet="hoverGradient" />
      } @else if (item.type === 'media') {
        <pxc-sequence-media class="block size-full" [media]="item.media">
          <ng-container *ngTemplateOutlet="hoverGradient" />
        </pxc-sequence-media>
      } @else {
        <pxc-file-media-preview class="block size-full" [file]="item.file" [showDelete]="false">
          <ng-container *ngTemplateOutlet="hoverGradient" />
        </pxc-file-media-preview>
      }
    </div>

    @if (selectable) {
      <div
        class="pointer-events-none absolute right-4 top-4 opacity-0 transition-opacity group-hover:opacity-100"
        [class.opacity-100!]="selected">
        @if (maxSelectable() === 1) {
          <input tuiRadio type="radio" [checked]="selected" [tabIndex]="-1" />
        } @else {
          <input tuiCheckbox type="checkbox" [checked]="selected" [tabIndex]="-1" />
        }
      </div>
    }
  </button>

  <ng-template #hoverGradient>
    @if (selectable) {
      <div
        class="pointer-events-none absolute inset-x-0 top-0 h-14 bg-linear-to-b from-black/40 to-transparent opacity-0 transition-opacity group-hover:opacity-100"
        [class.opacity-100!]="selected"></div>
    }
  </ng-template>
</ng-template>

<tui-scrollbar *transloco="let t" class="block flex-1 -mx-2">
  <div
    class="flex max-h-[50vh] flex-col gap-6 px-2 py-2"
    mode="element"
    scroll-tracker
    tuiFade="vertical"
    [bottomGuard]="isLoadingMore()"
    [isDisabled]="!hasMore()"
    [threshold]="{ top: 0, bottom: 300 }"
    (bottomThreshold)="loadMoreRequest.emit()">
    @if (uploadedFiles().length) {
      <div class="flex flex-col gap-2">
        <span tuiTitle>{{ t('Fichiers ajoutés') }}</span>
        <div class="grid grid-cols-3 gap-2 lg:grid-cols-5">
          @for (file of uploadedFiles(); track getFileKey(file)) {
            <ng-container *ngTemplateOutlet="tile; context: { $implicit: fileItem(file) }" />
          }
        </div>
      </div>
    }

    @for (group of groups(); track $index) {
      <ng-container *ngTemplateOutlet="groupTpl; context: { $implicit: group }" />
    }

    @if (isLoadingMore()) {
      <div class="flex items-center justify-center py-2" data-testid="media-picker-loading">
        <pxc-spinner />
      </div>
    }
  </div>
</tui-scrollbar>
